import { BaseClient } from "../../clients/base/BaseClient";
import { FILTERS_ENDPOINTS } from "./filters.consts";
import type {
  LocationsResponse,
  SampleTypesResponse,
  VisitTypesResponse,
  RequestersResponse,
  DoctorsResponse,
} from "./filters.types";

/**
 * Filters API Client
 * Handles all filter-related API operations.
 */
export class FiltersClient extends BaseClient {
  /**
   * Fetch locations and instruments.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<LocationsResponse>} Array of locations with instruments.
   */
  async fetchLocations(signal?: AbortSignal | null): Promise<LocationsResponse> {
    return this.get<LocationsResponse>(FILTERS_ENDPOINTS.LOCATIONS, {
      signal,
    });
  }

  /**
   * Fetch sample types.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<SampleTypesResponse>} Array of sample types.
   */
  async fetchSampleTypes(signal?: AbortSignal | null): Promise<SampleTypesResponse> {
    return this.get<SampleTypesResponse>(FILTERS_ENDPOINTS.SAMPLE_TYPES, {
      signal,
    });
  }

  /**
   * Fetch visit types.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<VisitTypesResponse>} Array of visit types.
   */
  async fetchVisitTypes(signal?: AbortSignal | null): Promise<VisitTypesResponse> {
    return this.get<VisitTypesResponse>(FILTERS_ENDPOINTS.VISIT_TYPES, {
      signal,
    });
  }

  /**
   * Fetch requesters.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<RequestersResponse>} Array of requesters.
   */
  async fetchRequesters(signal?: AbortSignal | null): Promise<RequestersResponse> {
    return this.get<RequestersResponse>(FILTERS_ENDPOINTS.REQUESTERS, {
      signal,
    });
  }

  /**
   * Fetch ordering doctors.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<DoctorsResponse>} Array of doctors.
   */
  async fetchDoctors(signal?: AbortSignal | null): Promise<DoctorsResponse> {
    return this.get<DoctorsResponse>(FILTERS_ENDPOINTS.DOCTORS, {
      signal,
    });
  }
}
